 import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";
import { inject, observer } from "mobx-react";
import React, { FC } from "react";
import { ProductAttributeWithOption } from "../../../../../shared/models";
import { DescriptionCell, LabelCell } from "../../../../../shared/styles";
import { ColorBox } from "../../../../../shared/components";
 
type IProps = {
  attributeMappings: ProductAttributeWithOption[];
};

const AttributeSection: FC<IProps> = ({ attributeMappings }) => {
  return (
      <>
          <CustomLabel fontSize={'20px'} fontWeight="600" margin="30px 0px 30px">
              Attributes
          </CustomLabel>
          <FlexContainer fxLayout="column">
              {attributeMappings.map((attribute, idx) => {
                  return (
                      <FlexContainer key={idx} className="label-description-row">
                          <LabelCell>{attribute.attributeName}</LabelCell>
                          <DescriptionCell>
                              <FlexContainer alignItems="center" spacing={30}>
                                  <div>{attribute.optionName} </div>
                                  <div>
                                      {attribute.valueType === 'Color' && attribute.color && (
                                          <ColorBox color={attribute.color} />
                                      )}
                                  </div>
                              </FlexContainer>
                          </DescriptionCell>
                      </FlexContainer>
                  );
              })}
          </FlexContainer>
      </>
  );
};
export default inject('itemStore')(observer(AttributeSection));

